import { render, staticRenderFns } from "./svg.vue?vue&type=template&id=78e7ced7&"
import script from "./svg.vue?vue&type=script&lang=ts&"
export * from "./svg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports